import { Button } from '@/components/ui/button';
import { cn } from '@/utils';

import SearchingBookImage from './assets/greyed-book.svg';

export interface EmptyListProps {
  onJoinWaitlist?: () => void;
  isSelected?: boolean;
  className?: string;
}

export const EmptyList = ({
  onJoinWaitlist,
  isSelected,
  className,
}: EmptyListProps) => {
  return (
    <div className={cn('flex flex-col gap-4 items-center w-full', className)}>
      <div className="relative w-[120px] h-[120px]">
        <img
          src={SearchingBookImage}
          alt="No batches available"
          className="absolute inset-0 w-full h-full object-cover object-center pointer-events-none"
        />
      </div>

      <p className="capitalize font-bold leading-7 text-[20px] text-magical-moonlight-d4 text-center whitespace-nowrap">
        Oops, No Batches Available :(
      </p>

      <Button
        onClick={onJoinWaitlist}
        variant="outline"
        size="md"
        disabled={isSelected}
      >
        {isSelected ? 'Waitlisted' : 'Join Waitlist'}
      </Button>
    </div>
  );
};
